import { useQuery } from '@tanstack/react-query'

import { getTaxCatalogue } from 'services/catalogues'
import { selectCatalogue } from 'lib/helpers/selectors'

import { TaxCatalogue } from 'models/invoices.models'
import { QueryOptions } from 'models/general'
import { useAppSelector } from 'store/hooks'

export const useTaxCatalogue = (options: QueryOptions<TaxCatalogue> = {}) => {
  const satCatalogue = useAppSelector(selectCatalogue('impuestos'))

  const { ...rest } = options

  const query = useQuery<TaxCatalogue, any>(
    ['get-tax-catalogue'],
    () => {
      return getTaxCatalogue(satCatalogue)
    },
    {
      ...rest,
    }
  )

  return query
}
